import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from '../styles/pages/interest_rates_page.module.css';
import ModalLoanInterest from '../components/ModalLoanInterest';
import { useAuth } from "../authentication/AuthContext";
import ModalCreateLoanType from '../components/ModalCreateLoanType';
function LoanInterestRates() {
  const [rates, setRates] = useState([]);
  const [ratesInput, setRatesInput] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingInput, setLoadingInput] = useState(true);
  const { isAuthenticated } = useAuth();
   const [showCreateModal, setShowCreateModal] = useState(false);
  useEffect(() => {
    const fetchRates = async () => {
      try {
        const response = await axios.get('/api/loanRates');
        if (response.data && response.data.data) {
          setRates(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching interest rates:", error);
      } finally {
        setLoading(false);
      }
    };

   const fetchRatesInput = async () => {
  try {
    const response = await axios.get('/api/loanRateInput');
    console.log(response.data.content);
    if (response.data) {
      setRatesInput(response.data.content); // this is now an object
      
    }
  } catch (error) {
    console.error("Error fetching interest rates Input:", error);
  } finally {
    setLoadingInput(false);
  }
};
    fetchRates();
    fetchRatesInput();
  }, []);
  const isLoading = loading || loadingInput;

  const postInterestRatesData = async (updatedRates) => {
    try {
      const response = await axios.post("/api/loanRates", updatedRates);

      if (response.data && response.data.message) {
        // Refresh the data
        const newData = await axios.get('/api/loanRates');
        setRates(newData.data.data);
        alert("Interest rates updated successfully!");
      }
    } catch (error) {
      console.error("Error updating interest rates:", error);
      alert("Failed to update interest rates.");
    }
  };


   const onCreated = (newLoanType) => {
    // Refresh rates to include new loan type
    setRates(prev => [...prev, newLoanType]);
    setShowCreateModal(false);
    alert('New loan type created successfully!');
  };

  return (
    <div className="body">
      <div className="heading">LOAN INTEREST RATES</div>
      <hr />
      <hr />

      <div className="body">
        <div style={{display:"flex", justifyContent: "space-evenly"}}>
       <p className={styles.wef}>{ratesInput}</p>

       {isAuthenticated && (
  <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
    <input
      value={ratesInput}
      onChange={(e) => setRatesInput(e.target.value)}
      style={{ flex: 1 }}
    />
    <button onClick={async () => {
      try {
        await axios.post('/api/loanRateInput', { content: ratesInput });
        alert("Content updated successfully!");
      } catch (err) {
        alert("Failed to update content.");
      }
    }}>
      Save
    </button>
  </div>
)}

          {isAuthenticated  && (  
         <button onClick={() => setShowCreateModal(true)}>Create New Loan Type</button>
          )}
          {showCreateModal && (
        <ModalCreateLoanType
          onClose={() => setShowCreateModal(false)}
          onCreated={onCreated}
        />
      )}
</div>
        {isLoading ? (
          <p>Loading...</p>
        ) : (
          rates.map((rateGroup) => (
            <div key={rateGroup._id} className={styles.table} style={{ marginBottom: '2rem' }}>
              
              {/* Header row with modal inside */}
              <div className={`${styles.head} ${styles.row}`}>
                
                  <p className={styles.col1}>{rateGroup.loan_type}</p>
                <p className={styles.col2}>INTEREST RATE</p>
                {isAuthenticated  && (  
                <ModalLoanInterest
                 loanTypeId={rateGroup._id}
                    onSubmit={(updatedBrackets) => {
                      const updated = { loan_type: rateGroup.loan_type, brackets: updatedBrackets };
                      postInterestRatesData(updated);
                    }}
                    value={rateGroup.brackets.filter(b => b.range && b.interest_rate !== '')}
                  />
                )}
              </div>

              {/* Bracket rows */}
              {rateGroup.brackets.map((item, i) => (
                item.range && item.interest_rate !== '' && (
                  <div key={item._id || i} className={styles.row}>
                    <p className={styles.col1}>{item.range}</p>
                    <p className={styles.col2}>{item.interest_rate}%</p>
                  </div>
                )
              ))}

            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default LoanInterestRates;
